import { request } from '@umijs/max';
import { RequestType } from '@/interface';
import { OwnerAssetsCountType, OwnerAssetsType } from '@/pages/Mine/interface';
// import { config } from '@/utils/config';
// import qs from 'qs';

/**
 *
 * @param data
 * @returns
 */
export const bindHouse = async (data?: any) => {
  return request('/api/community/owner/WechatOwnerBind', {
    method: 'post',
    data,
  });
};

/**
 * 查询业主绑定资源数量
 * @param ownerId
 * @returns
 */
export const queryOwnerDetail = async (ownerId?: string) => {
  return request<Promise<RequestType<OwnerAssetsCountType>>>(
    `/api/community/owner/WechatOwnerBind/bind/${ownerId}`,
    {
      method: 'get',
    },
  );
};

/**
 * 根据房屋查询车位车辆储藏室
 * @param roomId
 */
export const queryOwnerAssetDetail = async (roomId: string) =>
  request<Promise<RequestType<OwnerAssetsType>>>(
    `/api/community/owner/WechatOwnerBind/detail/${roomId}`,
    {
      method: 'get',
    },
  );

/**
 * 修改绑定信息
 * @param data
 */
export const queryUpdateOwnerDetail = async (data: any) =>
  request<Promise<RequestType<any>>>(
    '/api/community/owner/WechatOwner/update',
    {
      method: 'POST',
      data: data,
    },
  );

/**
 * 设置默认房屋
 * @param roomId
 */
export const querySetDefaultHouse = async (roomId: string) =>
  request<Promise<any>>(
    `/api/community/owner/WechatOwnerBind/set/default/${roomId}`,
    {
      method: 'POST',
    },
  );
